
function openPopup(pUrl, pWidth, pHeight) {
    if (!pWidth)  pWidth = 800;
    if (!pHeight) pHeight = 600;

    var sWidth  = screen.availWidth;
    var sHeight = screen.availHeight;
    var pTop    = sHeight / 2 - pHeight / 2;
    var pLeft   = sWidth / 2 - pWidth / 2;

    window.open(pUrl, 'popup', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes' +
                    ',width=' + pWidth + ',height=' + pHeight + ',top=' + pTop + ',left=' + pLeft);
}


function checkSidebarHeight() {
	$('.sidebar').each(function() {
		var sidebarHeight = $(this).outerHeight(true);
		var windowHeight  = $(window).height();

		windowHeight -= $('.navbar-fixed-top').outerHeight();

		if (sidebarHeight > windowHeight) {
			$(this).addClass('no-affix');
		} else {
			$(this).removeClass('no-affix');
		}
	});
}


// function setGrayGlassHeight(perc) {
//     // if (parseInt($('.progress-glass-bar-gray').height()) == perc) {
//     //     return;
//     // }
//
//     $('.progress-glass-bar-1').show().animate({'height': perc + '%'}, 500, function() {
//         if (perc == 0) {
//             // $(this).fadeOut('fast');
//         }
//     });
// }

// function setGlassHeight(perc) {
//     // if (parseInt($('.progress-glass-bar').height()) == perc) {
//     //     return;
//     // }
//
//     $('.progress-glass-bar-2').show().animate({'height': perc + '%'}, 500, function() {
//         if (perc == 0) {
//             // $(this).fadeOut('fast');
//         }
//     });
// }


function scrollTo($element, offset, duration) {
    if ($element.length === 0) return;

    if (duration === undefined) {
        duration = 1000;
    }

    $([document.documentElement, document.body]).animate({
        scrollTop: $element.offset().top + (offset === undefined ? 0 : parseInt(offset))
    }, duration);
}
